@use '@scss/typography';
.table-container .data-table .data-table-head .data-table-row {
  display: table-row;
}
.table-container .data-table .data-table-head .data-table-row .data-table-head-cell {
  height: 4rem;
  white-space: nowrap;
}
.table-container .data-table .data-table-body {
  background-color: transparent;
}
.table-container .data-table .data-table-body .data-table-row {
  display: table-row;
  border-bottom: 1px solid var(--transaction-table-border-color);
}
.table-container .data-table .data-table-body .data-table-row .data-table-cell {
  border: none;
  display: table-cell;
  height: 6rem;
}
.table-container .data-table .data-table-body .data-table-row .data-table-cell .data-table-cell-caption {
  display: none;
}
.table-container .data-table .data-table-body .data-table-row:hover {
  background-color: var(--table-container-row-hover-color);
}
.table-container .table-header-cell {
  color: var(--transaction-table-header-color);
  background-color: var(--transaction-table-header-background-color);
  @extend %caption-medium;
}
.table-container .table-header-cell span {
  padding: 0 1.6rem;
}
.table-container .table-cell {
  @extend %bodyS-regular;
  color: var(--transaction-table-cell-color);
  padding: 0 1.6rem;
}
.table-container .transaction-date {
  display: grid;
}
.table-container .transaction-date .hours {
  color: var(--transaction-table-hours-color);
}
.table-container .transaction-id {
  font-weight: 700;
}
.table-container .stroke {
  text-decoration-line: line-through;
}
.table-container .amount-container {
  @extend %bodyS-medium;
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: flex-end;
}
.table-container .amount-container .amount-container-currency {
  @extend %label;
  font-weight: 600;
}
.table-container .counterparty-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.table-container .type-container {
  @extend %bodyS-medium;
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: flex-end;
  text-transform: capitalize;
}
.table-container .cancelled {
  text-decoration: line-through;
}
